/**
 * SDK de telemetría de store-ui.
 *
 * El motor (core, instrumentación, bindings React) vive en el paquete
 * compartido `@lala/telemetry-sdk`. Aquí solo queda el cableado de store:
 * el cliente singleton y el adapter de dominio (helpers de e-commerce).
 *
 * Uso:
 *   import { getTelemetry, trackProductView } from '~/sdk';
 */
export { getTelemetry } from './client';
export { StoreEventTypes } from './store/events';
export type { StoreEventType } from './store/events';
export * from './store/ecommerce';

// Re-export de los bindings React del paquete para conveniencia.
export { TelemetryProvider, useTelemetry } from '@lala/telemetry-sdk/web/react';
